
import './App.css';
import { RouterProvider, createBrowserRouter } from 'react-router-dom';
import First from './levels/first/first';
import Second from './levels/second/second';
import Third from './levels/third/third';
import Fourth from './levels/fourth/fourth';
import Fifth from './levels/fifth/fifth';
import Sixth from './levels/sixth/sixth';
import Seventh from './levels/seventh/seventh';
import Cheating from './levels/cheating/cheating';
import Start from './levels/start/start';
import Reset from './levels/reset/reset';

const router = createBrowserRouter([
  {
    path: "/",
    element: <Start />,
  },
  {
    path: "/first",
    element: <First />,
  },
  {
    path: "/second",
    element: <Second />,
  },
  {
    path: "/third",
    element: <Third />,
  },
  {
    path: "/fourth",
    element: <Fourth />,
  },
  {
    path: "/fifth",
    element: <Fifth />,
  },
  {
    path: "/sixth",
    element: <Sixth />
  },
  {
    path: "/seventh",
    element: <Seventh />
  },
  {
    path: "/cheating",
    element: <Cheating />,
  },
  {
    path: "/reset",
    element: <Reset />
  }
]);

function App() {
  return (
    <div className="wrapper">
      <RouterProvider router={router} />
    </div>
  );
}

export default App;
